import React from 'react';

import {
  useDashboardCVAdminData,
  useDashboardLastUploadRoles,
  useDashboardRecordsActivity,
} from 'src/hooks/dashboard';

import { DashboardRecordsActivityBlock } from '../DashboardRecordsActivityBlock';

export const DashboardGlobalCVAdminRecordsActivityBlock: React.FC = () => {
  const { dataset, counts, loading } = useDashboardRecordsActivity();

  const { employers, peos } = useDashboardCVAdminData();

  // MDM answers for one org at a time, so the last load is only shown when the filter narrows the
  // dashboard to a single Employer or a single PEO — anything else has no single-org answer.
  const isSingleEmployerSelected = employers?.length === 1 && !peos?.length;
  const isSinglePeoSelected = peos?.length === 1 && !employers?.length;

  const { lastUploadRoles } = useDashboardLastUploadRoles({
    employerId: isSingleEmployerSelected ? employers?.[0]?.id : null,
    peoId: isSinglePeoSelected ? peos?.[0]?.id : null,
  });

  return (
    <DashboardRecordsActivityBlock
      dataset={dataset}
      counts={counts}
      lastUploadRoles={lastUploadRoles}
      loading={loading}
    />
  );
};
